import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';

import RouteMarker from './route-marker';

// disable array-idx-key-warning around index; locations may have identical lat/lon
/* eslint-disable react/no-array-index-key */
function RouteMarkers({ route }) {
  return (
    <>
      {route.map((location, index) => (
        <RouteMarker
          location={location}
          isFirst={index === 0}
          isLast={index === route.length - 1}
          key={`location-${index}-${get(location, 'properties.timestamp', '')}${location.geometry.coordinates[1]}${location.geometry.coordinates[0]}`}
        />
      ))}
    </>
  );
}
RouteMarkers.defaultProps = {
  route: [],
};
RouteMarkers.propTypes = {
  route: PropTypes.arrayOf(PropTypes.object),
};

export default RouteMarkers;
